import { Component, OnInit } from '@angular/core';
import { WorkFilesService } from '../../services/work-files.service';
import { FileUploadConfig } from './components/file-upload-card/file-upload-card.component';

@Component({
    selector: 'app-sending-files',
    templateUrl: './sending-files.component.html',
    styleUrl: './sending-files.component.scss',
    standalone: false
})
export class SendingFilesComponent implements OnInit {
  workNotificationConfig!: FileUploadConfig;
  workOrderConfig!: FileUploadConfig;
  workOrderOperationsConfig!: FileUploadConfig;

  constructor(private workFilesService: WorkFilesService) {}

  ngOnInit() {
    this.workNotificationConfig = {
      title: 'Avis de travail',
      icon: 'pi pi-file-edit',
      iconColor: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-100 dark:bg-blue-900',
      jobId: 'work-notification-reconciliation',
      uploadMethod: (file: File) => this.workFilesService.uploadWorkNotificationFile(file)
    };

    this.workOrderConfig = {
      title: 'Les ordres de travail',
      icon: 'pi pi-list',
      iconColor: 'text-purple-600 dark:text-purple-400',
      bgColor: 'bg-purple-100 dark:bg-purple-900',
      jobId: 'work-order-reconciliation',
      uploadMethod: (file: File) => this.workFilesService.uploadWorkOrderFile(file)
    };

    this.workOrderOperationsConfig = {
      title: 'Opérations des ordres de travail',
      icon: 'pi pi-cog',
      iconColor: 'text-orange-600 dark:text-orange-400',
      bgColor: 'bg-orange-100 dark:bg-orange-900',
      jobId: 'work-order-operations-reconciliation',
      uploadMethod: (file: File) => this.workFilesService.uploadWorkOrderOperationsFile(file)
    };
  }
}
